// Vuex connections module actions

import { API } from '@/config';
import { hParseToFilterCriteriaObjectRequiredByApi } from '@/utils/helpers';

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
} from './mutations-types';

export default {
  async getList({ state, commit }) {
    try {
      const params = {
        filtering_criteria: hParseToFilterCriteriaObjectRequiredByApi(state.filteringCriteria),
        page: state.list.page,
      };
      const { records, total } = (await API.get('/reports/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  filterList({ commit, dispatch }, params) {
    try {
      const filterCriteria = {};
      Object.keys(params).forEach((key) => {
        if (params[key] !== '') {
          filterCriteria[key] = {
            value: params[key],
            name: key,
            label: key,
          };
        }
      });
      commit(SET_FILTERING_CRITERIA, { ...filterCriteria });
      commit(SET_PAGE, { page: 1 });
      dispatch('getList');
    } catch (err) {
      console.log(err);
    }
  },

  clearSortingCriteria({ commit }) {
    commit(SET_PAGE, { page: 1 });
  },

  clearFilteringCriteria({ commit }) {
    commit(SET_FILTERING_CRITERIA, {});
    commit(SET_PAGE, { page: 1 });
  },
  changePage({ commit, dispatch }, page) {
    commit(SET_PAGE, { page });
    dispatch('getList');
  },
};
